<div class="d-flex mt-3">
  <label class="col fw-bold d-block">
    @if (props.required) {
      <span class="text-colour-red-600">
        *
      </span>
    }
    {{ props.label }}
  </label>
  @if (props.tooltip) {
    <i
      class="col-1 far fa-question-circle my-auto"
      (click)="openTooltip()"
    ></i>
  }
</div>

<div class="d-flex mt-1">
  <div class="col-7">
    <div
      class="input-group"
      [ngClass]="props.inputClass"
      [class.is-invalid]="showError"
      [class.disabled]="formControl.disabled"
    >
      @if (props.addonStart) {
        <span
          class="input-group-text"
          [ngClass]="props.addonStartClass"
        >
          {{ props.addonStart }}
        </span>
      }

      <input
        type="text"
        class="form-control"
        maxlength="11"
        mask="separator.0"
        thousandSeparator=","
        [formControl]="$any(formControl)"
        [placeholder]="props.placeholder"
        [formlyAttributes]="field"
        [attr.data-testid]="props.testId"
      />

      @if (props.addonEnd) {
        <span
          class="input-group-text"
          [ngClass]="props.addonEndClass"
        >
          {{ props.addonEnd }}
        </span>
      }
    </div>
  </div>
  <div class="col-5 d-flex justify-content-end">
    <button
      class="btn"
      [disabled]="props.disabled"
      [ngClass]="props.button.className ?? ''"
      [class.disabled]="formControl.disabled"
      [type]="props.button.type ?? 'button'"
      [attr.data-testid]="props.testId + '_btn'"
      (click)="!props.button.onClick || props.button.onClick(field)"
    >
      @if (props.button.iconClass) {
        <i [ngClass]="props.button.iconClass"></i>
      }
      {{ props.button.label }}
    </button>
  </div>
</div>

@if (showError) {
  <div class="d-flex gap-3 align-items-center mt-2 alert alert-danger ">
    <i class="fas fa-times-circle"></i>
    <span>
      <formly-validation-message [field]="field" />
    </span>
  </div>
}
